import { ADD_INVESTASI } from "redux/constants/admin/masterdata/constants";

const initialState = {
    loading: false,
    loadingAction: false,
    isModalAction: false,
    submitSuccess: false,

    dataSimpananSukarela: {
        data: [],
        count: 0,
    },

    queryKey: "",
    selectedIds: [],

    cache: {},
    loadingByKey: {},
};

const investasiReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_INVESTASI.LOADING_DATA_INVESTASI_SUCCESS:
            return {
                ...state,
                loading: action.load,
            };

        case ADD_INVESTASI.LOADING_ACTION_INVESTASI:
            return {
                ...state,
                loadingAction: action.load,
            };

        case ADD_INVESTASI.IS_MODAL_ACTION_INVESTASI:
            return {
                ...state,
                isModalAction: action.load,
            };

        case ADD_INVESTASI.GET_DATA_INVESTASI_SUCCESS:
            return {
                ...state,
                dataSimpananSukarela: action.data,
            };

        case ADD_INVESTASI.INVESTASI_SUCCESS:
            return {
                ...state,
                submitSuccess: true,
            };

        case ADD_INVESTASI.INVESTASI_RESET:
            return {
                ...state,
                submitSuccess: false,
            };

        case ADD_INVESTASI.SET_QUERY_KEY:
            return {
                ...state,
                queryKey: action.key,
            };

        case ADD_INVESTASI.ADD_SELECTED_IDS:
            return {
                ...state,
                selectedIds: Array.from(
                    new Set([...state.selectedIds, ...action.ids])
                ),
            };

        case ADD_INVESTASI.REMOVE_SELECTED_IDS:
            return {
                ...state,
                selectedIds: state.selectedIds.filter(
                    (id) => !action.ids.includes(id)
                ),
            };

        case ADD_INVESTASI.CLEAR_SELECTED_IDS:
            return {
                ...state,
                selectedIds: [],
            };

        case ADD_INVESTASI.SET_CACHE_ENTRY:
            return {
                ...state,
                cache: {
                    ...state.cache,
                    [action.key]: action.data,
                },
            };

        case ADD_INVESTASI.SET_LOADING_FOR_KEY:
            return {
                ...state,
                loadingByKey: {
                    ...state.loadingByKey,
                    [action.key]: action.loading,
                },
            };

        case ADD_INVESTASI.UPDATE_CACHE_ITEMS: {
            const updatedCache = { ...state.cache };

            Object.keys(updatedCache).forEach((key) => {
                const entry = updatedCache[key];
                if (!entry?.data) return;

                updatedCache[key] = {
                    ...entry,
                    data: entry.data.map((item) =>
                        action.changesById[item.id]
                            ? { ...item, ...action.changesById[item.id] }
                            : item
                    ),
                };
            });

            return {
                ...state,
                cache: updatedCache,
            };
        }

        default:
            return state;
    }
};

export default investasiReducer;
